"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.insertSelect = void 0;
const dom_utils_1 = require("../utils/dom-utils");
const intlTelInput = require("intl-tel-input");
const currentCountry_1 = require("../services/currentCountry");
const contactNumbers_1 = require("./utils/contactNumbers");
const currentData = new currentCountry_1.CurrentCountry;
const contactNumbers = new contactNumbers_1.ContactNumbers;
function insertSelect() {
    return __awaiter(this, void 0, void 0, function* () {
        const inputs = Array.from((0, dom_utils_1.queryAll)(`[name="phoneNumber"]`));
        let country;
        try {
            country = yield currentData.getCountry();
        }
        catch (error) {
            country = 'Default';
        }
        inputs.forEach(input => {
            const iti = intlTelInput(input, {
                initialCountry: country.toLowerCase().replace(/"/g, ''),
                separateDialCode: true,
            });
            setPhoneData(iti);
            setCountryField();
            input.addEventListener('countrychange', () => {
                setPhoneData(iti);
                setCountryField();
            });
        });
        contactNumbers.setContactNumber(country.toUpperCase().replace(/"/g, ''));
        function setPhoneData(iti) {
            var _a;
            const selectedCountry = document.querySelector('.iti__selected-country');
            const countryCode = document.querySelector('.iti__selected-dial-code');
            const countryInput = (0, dom_utils_1.elementId)('country');
            const codeInput = (0, dom_utils_1.elementId)('diallingCode');
            if (countryInput && selectedCountry) {
                countryInput.value = (_a = selectedCountry.getAttribute('title')) !== null && _a !== void 0 ? _a : '';
            }
            if (codeInput && countryCode) {
                codeInput.value = countryCode.innerHTML;
            }
            contactNumbers.setContactNumber(iti.getSelectedCountryData().iso2.toUpperCase());
        }
        function setCountryField() {
            const selectedCountry = document.querySelector('.iti__selected-country');
            const country = document.querySelector('[name="sm_country"]');
            if (country && selectedCountry) {
                const title = selectedCountry.getAttribute('title');
                if (title !== null) {
                    country.value = title;
                }
            }
        }
    });
}
exports.insertSelect = insertSelect;
